export default __webpack_public_path__ + "static/media/cif-et.dfd0868d.svg";